import {AxiosProgressEvent} from 'axios';

/* eslint-disable @typescript-eslint/no-explicit-any */
export type HttpMethod = 'post' | 'get' | 'put' | 'delete' | 'patch';

export interface RequestOption {
	readonly method: HttpMethod;
	readonly url: string;
	readonly headers?: any;
	readonly body?: any;
	readonly params?: any;
	readonly responseType?: any;
	readonly onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
	readonly signal?: AbortSignal;
}

export enum HttpStatusCode {
	ok = 200,
	created = 201,
	noContent = 204,
	redirect = 301,
	badRequest = 400,
	unauthorized = 401,
	forbidden = 403,
	notFound = 404,
	conflict = 409,
	preconditionFailed = 412,
	unprocessable = 422,
	tooManyRequests = 429,
	serverError = 500,
}

export type HttpResponse<T> = {
	status: HttpStatusCode;
	data: T;
	headers?: Record<string, string>;
};

export interface HttpClient<T = any> {
	request(requestOption: RequestOption): Promise<HttpResponse<T>>;
}
